
import { Component, OnInit, Input, Renderer2, OnDestroy } from '@angular/core';
import { Drink } from 'src/interfaces/drink.model';
import { Labels } from 'src/interfaces/enums.model';
import { DataService } from 'src/app/services/data.service';
import { BasketService } from 'src/app/services/basket.service';
import { MatDialog } from '@angular/material/dialog';
import { MenuDrinkDialogComponent } from '../menu-drink-dialog/menu-drink-dialog.component';
import { sheetDialogConfig } from 'src/app/directives/sheet.directive';
import { ScrollService } from 'src/app/services/scroll.service';

import { cloneDeep } from 'lodash-es';
import { Subject, Subscription, takeUntil } from 'rxjs';
import { LocalizationService } from 'src/app/services/localization.service';
import { Locale } from 'src/interfaces/locale.model';

@Component({
    selector: 'app-drink-card',
    templateUrl: './menu-drink-card.component.html',
    styleUrls: ['./menu-drink-card.component.css'],
    standalone: false
})

export class DrinkCardComponent implements OnInit, OnDestroy {
  constructor(
    private dataService: DataService,
    private basketService: BasketService,
    private scrollService: ScrollService,
    private localization: LocalizationService,
    private dialog: MatDialog
  ) {
    this.locale = this.dataService.locale;
  }
  locale: Locale | null = null;

  basketDrink: Drink | null = null;

  @Input() drink: Drink | null = null;
  @Input() stoplist: boolean = false;
  @Input() isLast: boolean = false;

  Labels = Labels;

  private destroy$ = new Subject<void>();

  ngOnInit(): void {
    if (this.drink) {

      // Подписка на изменения корзины
      this.basketService.drinks
        .pipe(takeUntil(this.destroy$))
        .subscribe((data: Drink[]) => {
          let basketDrinks = data;
          const existingDrink = basketDrinks.find(f => f.id === this.drink?.id);

          if (existingDrink) {
            this.basketDrink = existingDrink;
          } else {
            this.basketDrink = null;
          }
        });
    }
  }

  onCardClicked(): void {
    if (this.stoplist || !this.drink) {
      return;
    }

    // Затемняем строку состояния перед открытием модального окна
    document.querySelector('meta[name="theme-color"]')?.setAttribute('content', '#a6a6ae');

    this.scrollService.setScrollEnabled(false);
    const dialogRef = this.dialog.open(MenuDrinkDialogComponent,
      sheetDialogConfig(this.basketDrink ? cloneDeep(this.basketDrink) : cloneDeep(this.drink)));

    dialogRef.afterClosed().subscribe(() => {
      this.scrollService.setScrollEnabled(true);

      // Возвращаем исходный цвет строки состояния
      document.querySelector('meta[name="theme-color"]')?.setAttribute('content', '#f5f5ff');
    });
  }

  ngAfterViewInit(): void {
    if (this.isLast) {
      console.log('DrinkCardComponent | onLastItemRendered | List rendering complete');
      this.dataService.setListRendered(true);
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
